<template>
  <div class="container__wrapper">
    <div class="pis-container">
      <div class="pis-body">
        <div class="pis-ads">
          <Player />
        </div>
        <div class="pis-queue">
          <div class="pis-queue__block">
            <div class="pis-queue__panel pis-queue__panel--green">
              <div class="pis-queue__panel__head">
                <h1>GEN. COLLECTION OR CEDULA</h1>
              </div>
              <div class="pis-queue__panel__body">
                <div
                  v-for="queue in getCounterByGroupId(1)"
                  :key="queue.hash_id"
                  :class="{
                    'pis-queue__item--active': isActive(queue)
                  }"
                  class="pis-queue__item"
                >
                  <div class="data-group">
                    <span class="data">{{ queue.short_name }}-</span>
                    <span class="data">{{ queue.current_count }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pis-queue__panel pis-queue__panel--blue">
              <div class="pis-queue__panel__head">
                <h1>RPT / BUHIS</h1>
              </div>
              <div class="pis-queue__panel__body">
                <div
                  v-for="queue in getCounterByGroupId(2)"
                  :key="queue.hash_id"
                  :class="{
                    'pis-queue__item--active': isActive(queue)
                  }"
                  class="pis-queue__item"
                >
                  <div class="data-group">
                    <span class="data">{{ queue.short_name }}-</span>
                    <span class="data">{{ queue.current_count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pis-queue__block">
            <div class="pis-queue__panel pis-queue__panel--red">
              <div class="pis-queue__panel__head">
                <h1>Business / Encoding</h1>
              </div>
              <div class="pis-queue__panel__body">
                <div
                  v-for="queue in getCounterByGroupId(3)"
                  :key="queue.hash_id"
                  :class="{
                    'pis-queue__item--active': isActive(queue)
                  }"
                  class="pis-queue__item"
                >
                  <div class="data-group">
                    <span class="data">{{ queue.short_name }}-</span>
                    <span class="data">{{ queue.current_count }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pis-queue__panel pis-queue__panel--red">
              <div class="pis-queue__panel__head">
                <h1>Business / Payment</h1>
              </div>
              <div class="pis-queue__panel__body">
                <div
                  v-for="queue in getCounterByGroupId(4)"
                  :key="queue.hash_id"
                  :class="{
                    'pis-queue__item--active': isActive(queue)
                  }"
                  class="pis-queue__item"
                >
                  <div class="data-group">
                    <span class="data">{{ queue.short_name }}-</span>
                    <span class="data">{{ queue.current_count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pis-foot">
        <DateTimePanel />
        <Announcement />
      </div>
    </div>
  </div>
</template>

<script>
import Announcement from '@components/Announcement'
import DateTimePanel from '@components/DateTimePanel'
import Player from '@components/Player'
import axios from 'axios'
import moment from 'moment'
import chunk from 'lodash/chunk'

export default {
  components: {Player, DateTimePanel, Announcement},
  data: () => ({
    queues: [],
    activeCounters: [],
  }),
  mounted() {
    this.$echo
      .channel('counter-called')
      .listen('CounterCalled', queue => {
        this.updateQueueBoard(queue)
      })
  },
  async created () {
    const response = await axios.get(this.route('current-status'))

    this.queues = response.data.data
  },
  methods: {
    chunk: chunk,
    isActive (queue) {
      return this.activeCounters.filter(counter => counter.counter_id === queue.id).length
    },
    getCounterByGroupId (groupId) {
      return this.queues.filter(queue => queue.group_id === groupId)
    },
    playSpeech(message) {
      const audio = new Audio('/audios/bell.mp3')
      audio.play()

      const msg = new SpeechSynthesisUtterance()
      msg.rate = 1
      msg.text = message
      window.speechSynthesis.speak(msg)
    },
    updateQueueBoard (queue) {
      const calledCounter = this
        .queues
        .map(counter => counter.id)
        .indexOf(queue.id)

      this.queues[calledCounter].current_count = queue.current_count_formatted

      this.playSpeech(`Calling number ${queue.current_count}, please proceed to ${queue.readable_name}, ${queue.name}`)

      setTimeout(() => {
        this.playSpeech(`Calling number ${queue.current_count}, please proceed to ${queue.readable_name}, ${queue.name}`)
      }, 3000)

      const activeCounter = this.activeCounters.findIndex(counter => counter.counter_id === queue.id)
      const currentTime = moment().add(10, 'second').toDate()

      if (activeCounter >= 0) {
        this.activeCounters[activeCounter].start_at = currentTime
      } else {
        this.activeCounters.push({
          counter_id: queue.id,
          start_at: currentTime,
        })
      }
    },
  },
}
</script>
